jQuery,
document.head.querySelector('meta[name="viewport"]').content = ( () => {
    let platform = navigator?.userAgent || navigator?.platform || "unknown";
    return /iPhone|iPod|iPad/.test(platform)
}
)() ? "width=device-width, initial-scale=1, maximum-scale=1" : "width=device-width, initial-scale=1",
$ = jQuery;
class CalculatorHistory {
    constructor() {
        this.history = []
    }
    saveCalculatorHistory(currentEntry) {
        const historyCopy = this.history.slice();
        historyCopy.unshift(currentEntry),
        this.history = historyCopy,
        this.history.length > 3 && this.history.splice(3)
    }
    displayCalculatorHistory(historyData) {
        const historyHTML = this.history.map(historyData).join("");
        setTimeout((function() {
            $("#cal-history").html(historyHTML)
        }
        ), 1500)
    }
}
let isSwpCalculator = "swp";
const calculatorConstants = {
    swp: {
        totalInvestment: {
            default: 1e5,
            min: 1e3,
            max: 1e7
        },
        withdrawalPerMonth: {
            default: 3e3,
            min: 500,
            max: 1e6
        },
        expectedReturns: {
            default: 2,
            min: 0,
            max: 40
        },
        tenure: {
            default: 2,
            min: 1,
            max: 30
        }
    }
};
let totalInvestment = calculatorConstants[isSwpCalculator].totalInvestment.default
  , withdrawalPerMonth = calculatorConstants[isSwpCalculator].withdrawalPerMonth.default
  , expectedReturns = calculatorConstants[isSwpCalculator].expectedReturns.default
  , tenure = calculatorConstants[isSwpCalculator].tenure.default;
const totalInvestmentHTML = document.getElementById("total-investment")
  , investedAmountHTML = document.getElementById("invested-amount")
  , estAmountHTML = document.getElementById("est-amount")
  , investmentTitle = document.getElementById("investment-title");
function updateSwpTextValues() {
    const totalReturnValue = calculateSwpReturn()
      , totalWithrawalValue = calculateSwpWithrawal();
    totalInvestmentHTML.innerHTML = getOuputFormat(totalReturnValue),
    investedAmountHTML.innerHTML = getOuputFormat(totalInvestment),
    estAmountHTML.innerHTML = getOuputFormat(totalWithrawalValue),
    barChart(Number(totalInvestment), Number(totalWithrawalValue))
}
function barChart(investment, returns) {
    const total = (investment + returns) / 100
      , returnsPercent = returns / total;
    updateBar("investment", minMaxBarPercent(investment / total)),
    updateBar("returns", minMaxBarPercent(returnsPercent))
}
function minMaxBarPercent(value) {
    return value < 1 ? 1 : value > 99 ? 99 : value
}
function updateBar(classInfo, width) {
    document.querySelector(`.distribution-bar .${classInfo}`).style.width = 100 * width + "%"
}
function forceValueRanges(input, type, forceMin=!1) {
    const value = Number(removeCharsFromString(input.val()))
      , allowedMax = calculatorConstants[isSwpCalculator][type].max
      , allowedMin = calculatorConstants[isSwpCalculator][type].min;
    value > allowedMax && input.val(getOuputFormat(allowedMax, input.data("type"))),
    forceMin && function forceMinValues() {
        value < allowedMin && value && input.val(getOuputFormat(allowedMin, input.data("type")))
    }()
}
function calculateSwpWithrawal() {
    return 12 * Number(withdrawalPerMonth) * Number(tenure)
}
function calculateSwpReturn() {
    const totalInvestmentValue = Number(totalInvestment)
      , withdrawalAmountValue = Number(withdrawalPerMonth)
      , tenureValue = Number(tenure)
      , expectedReturnsValue = Number(expectedReturns);
    let finswp = totalInvestmentValue * Math.pow(1 + expectedReturnsValue / 100, tenureValue) - withdrawalAmountValue * (Math.pow(Math.pow(1 + expectedReturnsValue / 100, 1 / 12) - 1 + 1, 12 * tenureValue) - 1) / (Math.pow(1 + expectedReturnsValue / 100, 1 / 12) - 1);
    return isNaN(finswp) && (finswp = 0),
    Math.round(finswp)
}
function updateTextValues() {
    return updateSwpTextValues()
}
function init() {
    updateTextValues()
}
function setHistoryValuesToInputFields(historyOBj, key) {
    $("input#investment").val(getOuputFormat(historyOBj[key].investment, "rupee")).trigger("input"),
    $("input#withdrawal-per-month").val(getOuputFormat(historyOBj[key].withdrawalPerMonth, "rupee")).trigger("input"),
    $("input#expected-returns-input").val(getOuputFormat(historyOBj[key].interest, "percent")).trigger("input"),
    $("input#tenure-input").val(getOuputFormat(historyOBj[key].time, "years")).trigger("input")
}
$("input#investment").on("input", (function(event) {
    forceValueRanges($("input#investment"), "totalInvestment"),
    totalInvestment = Number(removeCharsFromString(event.target.value))
}
)),
$("input#withdrawal-per-month").on("input", (function(event) {
    forceValueRanges($("input#withdrawal-per-month"), "withdrawalPerMonth"),
    withdrawalPerMonth = Number(removeCharsFromString(event.target.value))
}
)),
$("input#expected-returns-input-slider").on("input", (function(event) {
    expectedReturns = Number(event.target.value),
    $("input#expected-returns-input").val(getOuputFormat(expectedReturns, "percent"))
}
)),
$("input#expected-returns-input").on("input", (function(event) {
    forceValueRanges($("input#expected-returns-input"), "expectedReturns", !0),
    expectedReturns = Number(removeCharsFromString(event.target.value)),
    $("input#expected-returns-input-slider").val(expectedReturns).change()
}
)),
$("input#tenure-input-slider").on("input", (function(event) {
    tenure = Number(event.target.value),
    $("input#tenure-input").val(getOuputFormat(tenure, "years"))
}
)),
$("input#tenure-input").on("input", (function(event) {
    forceValueRanges($("input#tenure-input"), "tenure", !0),
    tenure = Number(removeCharsFromString(event.target.value)),
    $("input#tenure-input-slider").val(tenure).change()
}
)),
$("input[type=number]").on("keydown", (function(e) {
    ["-", "+", "e"].includes(e.key) && e.preventDefault()
}
)),
$(".cal-slider .form-group input").on("input", (function() {
    updateTextValues()
}
)),
init(),
$(".calc-slide .input").on("input", (function() {
    setInput($(this))
}
));
const calHistory = new CalculatorHistory;
$("#calculate").on("click", (function() {
    $(".last-three-calculations").show(),
    calHistory.saveCalculatorHistory({
        totalReturns: calculateSwpWithrawal(),
        estReturns: calculateSwpWithrawal(),
        investment: totalInvestment,
        withdrawalPerMonth: withdrawalPerMonth,
        interest: expectedReturns,
        time: tenure
    });
    let reopenIcon = document.location.origin + "/app/themes/upstox/dist/img/mutual-funds-return/view-more-icon.svg";
    calHistory.displayCalculatorHistory(( (data, index) => `<div class="expected-col" ><div class="common-col history-data">\n    <h6>Invested: <span class="invest-amount-history">${getOuputFormat(data.investment)}</span></h6>\n    <h6>Withdrawal Amount Per Month: <span class="withdrawal-history">${getOuputFormat(data.withdrawalPerMonth)}</span></h6>\n    <h6>Expected Returns: <span class="return-history">${getOuputFormat(data.interest, "percent")}</span></h6>\n    <h6>Tenure: <span class="time-history">${getOuputFormat(data.time, "years")}</span> </h6>\n    </div>  <a href="#swp-calculator" class="mobile-last-calc history-cal" data-id="${index}">Re-open <img src="${reopenIcon}"></a></div>`))
}
)),
$(document).ready((function() {
    $(document).on("click", ".history-cal", (function() {
        initializeSlider();
        const key = $(this).data("id");
        setHistoryValuesToInputFields(calHistory.history, key)
    }
    ))
}
)),
function($) {
    $(document).ready((function() {
        $(".txtcontact").focus((function() {
            $(this).parent().addClass("clicked")
        }
        )),
        $(".txtcontact").blur((function() {
            $(this).parent().removeClass("clicked")
        }
        ));
        const firstSection = $(".breadcrumbs-sec")
          , stickyBanner = $(".oda-bottom-footer-bar");
        $(window).scroll((function() {
            $(window).scrollTop() > firstSection.height() ? stickyBanner.css("display", "block") : stickyBanner.css("display", "none")
        }
        )),
        $(".btn.prple_btn").click((function() {
            $("#error-message").addClass("err-class")
        }
        ))
    }
    ))
}(jQuery);
const getHeightOfSlide = currentChild => {
    let calHeight = parseInt($(`#cal-slider .calc-slide:nth-child(${currentChild}) > div`).height())
      , paddingTop = parseInt($(`#cal-slider .calc-slide:nth-child(${currentChild})`).css("padding-top"));
    return calHeight + parseInt($(`#cal-slider .calc-slide:nth-child(${currentChild})`).css("padding-bottom")) + paddingTop
}
;
function initializeSlider() {
    const carouselSlides = document.querySelectorAll(".calc-slide")
      , btnNext = document.querySelector("#calculate")
      , backNext = document.querySelector("#back-button");
    let currentChild = 1
      , currentSlide = 0;
    $("#cal-slider").height(getHeightOfSlide(currentChild));
    const changeSlide = function(slides) {
        carouselSlides.forEach(( (slide, index) => {
            let pos = 100 * (index - slides);
            return index > 0 && (pos -= 100),
            slide.style.transform = `translateX(${pos}%)`
        }
        ))
    };
    changeSlide(currentSlide),
    btnNext.addEventListener("click", (function() {
        currentSlide++,
        currentChild++,
        carouselSlides.length - 1 < currentSlide && (currentSlide = 0),
        changeSlide(currentSlide),
        $("#cal-slider").height(getHeightOfSlide(currentChild)),
        setTimeout((function() {
            changeSlide(currentSlide + 2),
            currentChild++,
            $("#cal-slider").height(getHeightOfSlide(currentChild))
        }
        ), 1500)
    }
    )),
    backNext.addEventListener("click", (function() {
        carouselSlides.length - 1 < currentSlide && (currentSlide = 0),
        changeSlide(currentSlide),
        setTimeout((function() {
            changeSlide(--currentSlide),
            --currentChild,
            $("#cal-slider").height(getHeightOfSlide(currentChild))
        }
        ), 800),
        --currentChild,
        $("#cal-slider").height(getHeightOfSlide(currentChild))
    }
    ))
}
function removeCharsFromString(string) {
    return string.replace(/[^\d.]/g, "")
}
function addInput(operation, inputElement) {
    const currentValue = removeCharsFromString(inputElement.val())
      , newValue = Function(`return ${currentValue} ${operation} 1`)()
      , outputType = inputElement.data("type");
    newValue > 0 && inputElement.val(getOuputFormat(newValue, outputType)).trigger("input")
}
function setInput(currentInputElement) {
    let value = currentInputElement.val();
    const cursorPosition = currentInputElement[0].selectionStart
      , outputType = currentInputElement.data("type");
    value = removeCharsFromString(value),
    "" !== value && (value = getOuputFormat(value, outputType)),
    currentInputElement.val(value),
    "percent" != outputType && "years" != outputType || currentInputElement[0].setSelectionRange(cursorPosition, cursorPosition)
}
function getOuputFormat(value, type) {
    return "years" == type ? `${value}${value > 1 ? " years" : " year"}` : "percent" == type ? `${value}%` : "rupee" == type ? `₹ ${parseInt(Number(value))}` : "none" == type ? parseInt(Number(value)) : `₹ ${parseInt(Number(value)).toLocaleString("en-IN")}`
}
$(document).ready((function() {
    window.innerWidth < 767 && initializeSlider()
}
)),
$(".investment-main .number-tags li").on("click", (function() {
    const val = $(this).attr("value")
      , investmentInputElement = $("#investment");
    currentInvestmentValue = Number(removeCharsFromString(investmentInputElement.val())),
    investmentInputElement.val(getOuputFormat(parseInt(currentInvestmentValue) + parseInt(val))).trigger("input")
}
)),
$(".decrement").click((function() {
    addInput("-", $(this).next())
}
)),
$(".increment").click((function() {
    addInput("+", $(this).prev())
}
)),
function($) {
    $(document).ready((function() {
        $(".dynamic-faq").on("click", ".panel-trigger", (function() {
            var val = $(this).attr("val");
            $(".dynamic-faq").find(`.panel-collapse:not(${val})`).slideUp("fast");
            var inactiveTab = $(".dynamic-faq").find(`.panel-trigger:not([val="${val}"])`);
            $(this).toggleClass("collapsed"),
            $(val).slideToggle("fast"),
            inactiveTab.hasClass("collapsed") && inactiveTab.removeClass("collapsed")
        }
        )),
        $(".btn-all").click((function() {
            $(".smooth-wrap").addClass("smooth-wrap2"),
            $(".btn-all").hide(),
            $(".btn-less").show()
        }
        )),
        $(".btn-less").click((function() {
            $(".smooth-wrap").removeClass("smooth-wrap2"),
            $(".btn-all").show(),
            $(".btn-less").hide()
        }
        ))
    }
    ))
}(jQuery);
//# sourceMappingURL=swp.js.map
